import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';

interface Props {
  children: React.ReactNode;
}

const LoginLayout = ({ children }: Props) => {
  return (
    <Wrapper>
      <div className="inner">{children}</div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background-color: ${StyleConfig.COLOR.ECRU};
  width: 100%;
  height: 100%;
  min-height: 100vh;
  margin: auto;
  .inner {
    max-width: ${StyleConfig.SETTING.maxWidth}px;
    margin: 0 auto;
    padding: 8.53%;
  }
`;
export { LoginLayout };
export default LoginLayout;
